export const styles = {
  inputSpacing: {
    padding: '4px 0'
  }
};
